<template>
<div>
  <add-project-modal></add-project-modal>
  <div class="wrapper wrapper-content  animated fadeInRight">
    <div class="ibox">
      <div class="ibox-title">
          <h5>Projects</h5>
          <div class="ibox-tools">
              <a class="btn btn-primary btn-xs" data-toggle="modal" data-target="#add-project">Create new project</a>
          </div>
      </div>
      <div class="ibox-content">
        <project-filters></project-filters>
        <project-list></project-list>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import ProjectsFilters from './Filters.vue'
import ProjectsList from './List.vue'
import ProjectModal from './AddProjectModal.vue'
import { useProjectStore } from '../../../../stores/ProjectStore'

export default {
  setup () {
    const projectStore = useProjectStore()
    return { projectStore }
  },
  components: {
    projectFilters: ProjectsFilters,
    projectList: ProjectsList,
    addProjectModal: ProjectModal
  },
  mounted () {
    document.title = 'Projects :: PBN360 by Aphex Media'
    this.projectStore.loadProjects()
    this.$store.dispatch('loadUsers')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Projects.vue